import { ENTERPRISE_KEY, ENTERPRISE_SIGNATURE, DOMAIN, SOCKET_HOST, TEMP_UID, TEMP_TOKEN } from '../config/defaultSttings'
import ReconnectingWebSocket from 'reconnecting-websocket';
import router from '../router/index.js'
import store from '../store'
import { set, get, remove, } from '../utils/Cache';
let reconnectAttempts = 0; // 记录重连尝试次数
let Connection_status = false;
const api = {
  webSocket: '/webSocket'
}

export default api
export var hiddenValue = true
export var user_name
var ws = ''
var sn = 1
var receiveData = ''
var timerID = 0
let heartbeatTimer = null; // 心跳定时器
let heartbeatInterval = 10000; // 心跳间隔10秒
let reconnectCallbacks = []; // 重连成功回调列表

/**
 * 注册重连成功回调
 * @param {Function} callback 
 */
export function registerReconnectCallback(callback) {
  if (typeof callback === 'function') {
    reconnectCallbacks.push(callback);
    // 如果已经连接（握手成功），立即执行回调
    if (Connection_status) {
      try {
        callback();
      } catch (e) {
        console.error('立即执行重连回调失败:', e);
      }
    }
  }
}

/**
 * 注销重连成功回调
 * @param {Function} callback 
 */
export function unregisterReconnectCallback(callback) {
  reconnectCallbacks = reconnectCallbacks.filter(cb => cb !== callback);
}


/**
 * 心跳检查函数
 * 每30秒发送一次Ping命令保持连接活跃
 */
function startHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
  }
  
  heartbeatTimer = setInterval(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      const pingData = {
        cmd: "Ping",
        sn: sn + 1
      };
      sn = sn + 1;
      console.log("发送心跳:", pingData);
      ws.send(JSON.stringify(pingData));
    }
  }, heartbeatInterval);
}

/**
 * 停止心跳检查
 */
function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
    console.log("心跳已停止");
  }
}
// parameter：传递的参数，
export function webSocket(parameter, action) {
  if (ws.readyState === WebSocket.OPEN) {
    console.log('WebSocket连接已建立');
  } else if (ws.readyState === WebSocket.CONNECTING) {
    console.log('WebSocket正在连接');
  } else if (ws.readyState === WebSocket.CLOSING) {
    console.log('WebSocket正在关闭');
  } else if (ws.readyState === WebSocket.CLOSED) {
    console.log('WebSocket已关闭');
  }else {
    console.log('WebSocket未连接')
  }
  console.log('WebSocket连接状态: ', ws.readyState)
  console.log('传递参数', parameter);
  if (parameter && parameter.cmd == 'close') {
    console.log('关闭websocket')
    ws.close();
  }
  if (parameter.cmd == 'Authenticate') {
    console.log('begin create websocket:' + ws.readyState)
    ws = new WebSocket(SOCKET_HOST)
    // 打开webSocket
    ws.onopen = function () {
      console.log("onopen");
      console.log('连接状态为:' + ws.readyState)
      var auth = {
        'cmd': 'Authenticate',
        'sn': sn,
        'enterprise_info': {
          'enterprise_key': ENTERPRISE_KEY,
          'enterprise_signature': ENTERPRISE_SIGNATURE,
          'package_name': 'saas.com'
        },
        'user_info': {
          "uid": JSON.parse(get('uid')),
          "token": JSON.parse(get('token')),
        },
        'product_info': [{
          'product_key': '02031904080201808000191011gwony2',
          'product_secret': '0b147866c0bcb80fd48fc71998aa57d9',
          'not_standard': true
        },
        {
          'product_key': '25101903150201000000190808un20gq',
          'product_secret': '338ba68eb642c7f9bf4cf8ff4bfc7fdb',
          'not_standard': true
        }]
      }
      ws.send(JSON.stringify(auth))
      // 连接成功后启动心跳
      startHeartbeat();
    }
  } else {
    parameter.sn = sn + 1
    console.log(JSON.stringify(parameter))
    if (Connection_status === true) {
      ws.send(JSON.stringify(parameter))
    }else{
      console.log('socket连接未建立');
    }
  }
  // 接收数据事件
  ws.onmessage = function (evt) {
    receiveData = evt.data

      var receiveDataJson = JSON.parse(receiveData)
    // if (receiveDataJson.cmd != 'Pong') {
      console.log('phoenix返回的消息', receiveData)
      if (receiveDataJson.cmd === 'AuthenticateAck') {
        Connection_status = true
        console.log('握手成功');
        // 认证成功后确保心跳已启动
        startHeartbeat();
        // 执行所有注册的重连回调
        reconnectCallbacks.forEach(cb => {
          try {
            cb();
          } catch (e) {
            console.error('重连回调执行失败:', e);
          }
        });
        action(receiveData)
      }
      if (receiveDataJson.cmd === 'PushDeviceAttrStatus' || receiveDataJson.cmd === 'PushEvent') {
        if (router.currentRoute.value.path == '/deviceManage/device-detail' || '/') {
          action(JSON.parse(receiveData))
        }
      } 
      if (receiveDataJson.cmd === 'DeviceReportCommandAck' || receiveDataJson.cmd === 'DeviceSendCommandAck') {
        if (router.currentRoute.value.path == '/deviceManage/device-detail' || '/') {
          action(JSON.parse(receiveData))
        }
      }
      if (receiveDataJson.cmd === 'ExportDeviceHistoryKeyValueAck') {
        if (router.currentRoute.value.path == 'issueManage/dev-history') {
          action(JSON.parse(receiveData))
        }
      }
  }
  // ws.onerror = error()
  ws.onclose = function (e) {
    Connection_status = false
    console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
    // 连接关闭时停止心跳
    stopHeartbeat();
    // 每过1秒重连
    setTimeout(function () {
      var send_param = {'cmd':'Authenticate'}
      reconnectWebSocket(send_param, action);
    }, 1000); // 1秒后再次尝试重连
  }
}
// }
function reconnectWebSocket(parameter, action) {
  console.log('断开，准备重连');
  // 重连WebSocket的逻辑
  if (Connection_status === false) {
    console.log(`尝试第 ${reconnectAttempts + 1} 次重连`);
    webSocket(parameter, action); // 重新调用建立WebSocket连接的方法
    reconnectAttempts++;
  } else {
    console.log('WebSocket连接已建立，无需重连');
  }
}

function error() {
  console.log('连接错误')
}

function keepAlive() {
  var timeout = 5000;
  if (ws.readyState == 1) {
    console.log('send ping')
    ws.send('PING');
  }
  timerID = setTimeout(keepAlive, timeout)
}

function cancelKeepAlive() {
  if (timerID) {
    cancelTimeout(timerID)
  }
}

export function delSpace(s) {
  s = s.replace(/^\s+|\s+$/g, '')
  s = s.replace(/,\s+/g, ',')
  s = s.replace(/\s+,/g, ',')
  return s
}

export function getList(para) {
  return new Promise(function (resolve, reject) {
    webSocket((para), (res) => {
      resolve(res)
    })
  })
}

export function makeTableData(para, column, oriTableData) {
  const root = para
  console.log("root", root);
  console.log("column", column);
  console.log('oriTableData', oriTableData);
  if (root.record_count === 0) {
    var returnResult = {}
    returnResult.data = []
    returnResult.pageSize = 0
    returnResult.pageNo = 0
    returnResult.totalPage = 0
    returnResult.totalCount = 0
    return returnResult
  }

  if (typeof (oriTableData) != "undefined") {
    console.log('have oriTableData, will delete the old data')
    var returnResult = oriTableData
    returnResult.data.splice(0, returnResult.data.length)
    data = returnResult.data
  } else {
    console.log('no oriTableData, will create a new one')
    var returnResult = {}
    var data = []
  }
  const formatRepeatColumn = root.format.repeat_column
  const formatDistinctColumn = root.format.distinct_column
  // console.log(formatDistinctColumn)
  var i
  var j
  var columnItem
  var formatRepeatColumnItem
  var formatDistinctColumnItem
  var columnIndex = []

  // console.log(`column.length is: ${column.length}`)
  for (i = 0; i < column.length; i++) {
    columnItem = column[i]
    // console.log('columnItem ' + columnItem)
    if (formatRepeatColumn) {
      // console.log(`column.length is: ${formatRepeatColumn.length}`)
      for (j = 0; j < formatRepeatColumn.length; j++) {
        formatRepeatColumnItem = formatRepeatColumn[j]
        // console.log('formatRepeatColumnItem ' + formatRepeatColumnItem)
        if (columnItem === delSpace(formatRepeatColumnItem).split('.')[1]) {
          columnIndex[columnIndex.length] = (0 - j - 1)
        }
      }
    }
    if (formatDistinctColumn) {
      for (j = 0; j < formatDistinctColumn.length; j++) {
        formatDistinctColumnItem = formatDistinctColumn[j]
        // console.log(`columnItem ${columnItem}, formatDistinctColumnItem: ${delSpace(formatDistinctColumnItem).split('.')[1]}`)
        if (columnItem === delSpace(formatDistinctColumnItem).split('.')[1]) {
          // console.log('get the coulmn, index: ', j, columnItem, delSpace(formatDistinctColumnItem).split('.')[1])
          columnIndex[columnIndex.length] = j
        }
      }
    }
  }

  console.log('columnIndex ' + columnIndex)

  var indexNum
  var newItemNum = 0

  for (var resultArrayNum = 0; resultArrayNum < root.result.length; resultArrayNum++) {
    const resultRepeatColumn = root.result[resultArrayNum].repeat_column
    const resultDistinctColumn = root.result[resultArrayNum].distinct_column
    for (i = 0; i < resultDistinctColumn.length; i++) {
      var newItem = {}
      newItemNum += 1
      newItem.key = newItemNum + ((root.addition.which_page - 1) * root.addition.page_size)
      for (j = 0; j < column.length; j++) {
        if (columnIndex[j] < 0) {
          indexNum = (0 - columnIndex[j] - 1)
          newItem[column[j]] = resultRepeatColumn[indexNum]
        }
        if (columnIndex[j] >= 0) {
          indexNum = columnIndex[j]
          newItem[column[j]] = resultDistinctColumn[i][indexNum]
        }
      }
      // console.log(newItem)
      // console.log(`create one recored ${JSON.stringify(newItem)}`)
      data[data.length] = newItem
    }
  }

  console.log(data)
  returnResult.data = data
  returnResult.pageSize = root.addition.page_size
  returnResult.pageNo = root.addition.which_page
  returnResult.totalPage = root.addition.total_page
  returnResult.totalCount = root.addition.total_count

  return returnResult
}

export function wsQueryInit(action, viewPara, token, use_resource_group) {
  console.log('wsQueryInit', action, viewPara, token, use_resource_group);
  const wsQuery = {}
  const dataQuery = {}
  wsQuery.cmd = 'UserFormatDataQuery'
  wsQuery.sn = 100
  wsQuery.token = token
  wsQuery.data_query = dataQuery

  dataQuery.action = action
  if (action === 'select') {
    dataQuery.select = []
    dataQuery.where = []
    dataQuery.order = {}
    dataQuery.group = {}
    dataQuery.addition = {}
    Object.assign(dataQuery.addition, viewPara ? viewPara : { "pageNo": 1, "pageSize": 20 })
  }

  // if(use_resource_group == true){
  //   dataQuery.use_resource_group = true
  // }else{
  //   dataQuery.use_resource_group = false
  // }

  return wsQuery
}

export function wsSetSelect(wsQuery, table, column, join) {
  var select = wsQuery.data_query.select
  var selectArrayNum = select.length
  select[selectArrayNum] = {}
  select[selectArrayNum].table = table
  select[selectArrayNum].column = delSpace(column).split(',')
  // if(join){
  //   select[selectArrayNum].join = delSpace(join).split(',')
  // }

  return wsQuery
}

export function wsSetWhere(wsQuery, type, method, expression) {
  var where = wsQuery.data_query.where
  var expressionArray = delSpace(expression).split('.')
  if (expressionArray[1] == 'email' && expressionArray[2] == 'like') {
    expressionArray[3] = delSpace(expression).split('like.')[1]
  }

  if (type === 'single') {
    var table = expressionArray[0]
    for (var i = 0; i < where.length; i++) {
      if (where[i].table === table) break
    }
    var whereArrayNum = i
    if (!where[whereArrayNum]) where[whereArrayNum] = {}
    where[whereArrayNum].table = expressionArray[0]
    if (!where[whereArrayNum].column) {
      where[whereArrayNum].column = []
    }
    var columnNum = where[whereArrayNum].column.length
    where[whereArrayNum].column[columnNum] = {}
    where[whereArrayNum].column[columnNum].method = method
    where[whereArrayNum].column[columnNum].name = expressionArray[1]
    where[whereArrayNum].column[columnNum].option = expressionArray[2]
    where[whereArrayNum].column[columnNum].value = expressionArray[3]
  }
  if (type === 'double') {
    whereArrayNum = where.length
    where[whereArrayNum] = {}
    where[whereArrayNum].method = method
    where[whereArrayNum].first_table = expressionArray[0]
    where[whereArrayNum].first_column = expressionArray[1]
    where[whereArrayNum].option = expressionArray[2]
    where[whereArrayNum].second_table = expressionArray[3]
    where[whereArrayNum].second_column = expressionArray[4]
  }

  return wsQuery
}

export function wsSetOrder(wsQuery, desc, table, orderBy, sameRepeat) {
  var order = wsQuery.data_query.order

  order.desc = desc
  order.table = table
  order.order_by = orderBy
  if (sameRepeat) {
    order.same_repeat = delSpace(sameRepeat).split(',')
  }

  return wsQuery
}

export function wsSetGroup(wsQuery, table, groupBy) {
  var group = wsQuery.data_query.group

  group.table = table
  group.group_by = groupBy

  return wsQuery
}

export function wsSetInsertColumn(wsQuery, table, column) {
  wsQuery.data_query.table = table
  wsQuery.data_query.column = delSpace(column).split(',')

  return wsQuery
}

export function wsSetInsertValue(wsQuery, value) {
  if (value) {
    if (!wsQuery.data_query.value) wsQuery.data_query.value = []
    console.log(value)
    if (value.length > 0 && typeof (value[0]) == 'object') {
      wsQuery.data_query.value = value
    } else {
      wsQuery.data_query.value[wsQuery.data_query.value.length] = value
    }

  }

  return wsQuery
}

export function wsSetDeleteTable(wsQuery, table) {
  wsQuery.data_query.table = table
  return wsQuery
}

export function wsSetDeleteWhere(wsQuery, method, expression) {
  if (expression) {
    if (!wsQuery.data_query.where) {
      wsQuery.data_query.where = []
    }
    var expressionArray = delSpace(expression).split('.')
    var whereId = wsQuery.data_query.where.length
    wsQuery.data_query.where[whereId] = {}
    wsQuery.data_query.where[whereId].method = method
    wsQuery.data_query.where[whereId].name = expressionArray[0]
    wsQuery.data_query.where[whereId].option = expressionArray[1]
    wsQuery.data_query.where[whereId].value = expressionArray[2]
  }

  return wsQuery
}

export function wsSetDeleteRecord(wsQuery, expression) {
  if (expression) {
    var expressionArray = delSpace(expression).split('.')
    wsQuery.data_query.table = expressionArray[0]
    wsQuery.data_query.where = []
    wsQuery.data_query.where[0] = {}
    wsQuery.data_query.where[0].name = expressionArray[1]
    wsQuery.data_query.where[0].option = expressionArray[2]
    wsQuery.data_query.where[0].value = expressionArray[3]
  }
  return wsQuery
}

export function wsSetUpdateColumn(wsQuery, table, column) {
  wsQuery.data_query.table = table
  wsQuery.data_query.column = column
  return wsQuery
}

export function wsSetUpdateWhere(wsQuery, method, expression) {
  if (expression) {
    if (!wsQuery.data_query.where) {
      wsQuery.data_query.where = []
    }
    var expressionArray = delSpace(expression).split('.')
    var whereId = wsQuery.data_query.where.length
    console.log(`wsQuery.data_query.where.length: ${whereId}`)
    wsQuery.data_query.where[whereId] = {}
    wsQuery.data_query.where[whereId].method = method
    wsQuery.data_query.where[whereId].name = expressionArray[0]
    wsQuery.data_query.where[whereId].option = expressionArray[1]
    wsQuery.data_query.where[whereId].value = expressionArray[2]
  }
  return wsQuery
}

export function wsSetRequest(wsQuery, url, device, runStatus, protocolStatus, handleOnce, handleMqtt, handleMainLoop, delete_dev_node_list, params) {
  wsQuery.data_query.request_saas = {}
  wsQuery.data_query.request_saas.url = url
  wsQuery.data_query.request_saas.device = device
  wsQuery.data_query.request_saas.run_status = runStatus
  wsQuery.data_query.request_saas.protocol_status = protocolStatus
  wsQuery.data_query.request_saas.handle_once = handleOnce
  wsQuery.data_query.request_saas.handle_mqtt = handleMqtt
  wsQuery.data_query.request_saas.handle_main_loop = handleMainLoop
  wsQuery.data_query.request_saas.delete_dev_node_list = delete_dev_node_list
  wsQuery.data_query.request_saas.params = params
  return wsQuery
}

export function replaceEnum(tableData) {
  console.log(`tableData.data.length: ${tableData.data.length}`)
  for (var num = 0; num < tableData.data.length; num++) {
    // console.log(`now check ${num}`)
    if (tableData.data[num].stage) {
      // console.log('tableData.data[num].stage: ', tableData.data[num].stage)
      tableData.data[num].stage = tableData.data[num].stage.replace(/^0$/g, '导入')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^1$/g, '待检')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^2$/g, '初检合格')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^3$/g, 'toBeSale')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^4$/g, 'saled')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^5$/g, '出厂')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^6$/g, 'saled')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^7$/g, '已投放')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^8$/g, '投放完成')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^50$/g, '已回收')
      tableData.data[num].stage = tableData.data[num].stage.replace(/^999$/g, '异常')
    }
    if (tableData.data[num].issue_status) {
      tableData.data[num].issue_status = tableData.data[num].issue_status.replace(/^0$/g, 'unAlarmed')
      tableData.data[num].issue_status = tableData.data[num].issue_status.replace(/^1$/g, 'alarmedDeviceNum')
      tableData.data[num].issue_status = tableData.data[num].issue_status.replace(/^2$/g, 'alarmedDeviceNum')
      tableData.data[num].issue_status = tableData.data[num].issue_status.replace(/^3$/g, 'alarmProcessedNum')
      tableData.data[num].issue_status = tableData.data[num].issue_status.replace(/^4$/g, 'alarmRecovery')
    }
    if (tableData.data[num].alarm_status) {
      tableData.data[num].alarm_status = tableData.data[num].alarm_status.replace(/^0$/g, 'unAlarmed')
      tableData.data[num].alarm_status = tableData.data[num].alarm_status.replace(/^1$/g, 'alarmedDeviceNum')
      tableData.data[num].alarm_status = tableData.data[num].alarm_status.replace(/^2$/g, 'alarmedDeviceNum')
      tableData.data[num].alarm_status = tableData.data[num].alarm_status.replace(/^3$/g, 'alarmProcessedNum')
    }
    if (tableData.data[num].issue_type) {
      tableData.data[num].issue_type = tableData.data[num].issue_type.replace(/^0$/g, 'deviceAlarm')
      tableData.data[num].issue_type = tableData.data[num].issue_type.replace(/^1$/g, '其他报警')
      tableData.data[num].issue_type = tableData.data[num].issue_type.replace(/^2$/g, '设备状态')
      tableData.data[num].issue_type = tableData.data[num].issue_type.replace(/^3$/g, '电子围栏报警')
    }
    if (tableData.data[num].device_status) {
      tableData.data[num].device_status = tableData.data[num].device_status.replace(/^0$/g, 'offline')
      tableData.data[num].device_status = tableData.data[num].device_status.replace(/^1$/g, 'online')
      tableData.data[num].device_status = tableData.data[num].device_status.replace(/^2$/g, 'notActive')
    }
    if (tableData.data[num].user_type) {
      // console.log('tableData.data[num].user_type: ', tableData.data[num].user_type)
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^0$/g, '超级管理员')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^1$/g, '管理员')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^2$/g, '工程商')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^3$/g, '代理商')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^4$/g, '管理单位')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^5$/g, '监理单位')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^6$/g, '施工单位')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^7$/g, '施工人员')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^8$/g, '售后')
      tableData.data[num].user_type = tableData.data[num].user_type.replace(/^999$/g, '终端用户')
    }
    if (tableData.data[num].project_stage) {
      // console.log('tableData.data[num].project_stage: ', tableData.data[num].project_stage)
      tableData.data[num].project_stage = tableData.data[num].project_stage.replace(/^0$/g, 'projectApproved')
      tableData.data[num].project_stage = tableData.data[num].project_stage.replace(/^1$/g, 'projectConstruction')
      tableData.data[num].project_stage = tableData.data[num].project_stage.replace(/^2$/g, 'projectAcceptance')
      tableData.data[num].project_stage = tableData.data[num].project_stage.replace(/^3$/g, 'projectCompleted')
    }
    /* if (tableData.data[num].recharge_status) {
      // console.log('tableData.data[num].project_stage: ', tableData.data[num].project_stage)
      tableData.data[num].recharge_status = tableData.data[num].recharge_status.replace(/^0$/g, '未续费')
      tableData.data[num].recharge_status = tableData.data[num].recharge_status.replace(/^1$/g, '待处理')
      tableData.data[num].recharge_status = tableData.data[num].recharge_status.replace(/^2$/g, '已处理,待确认')
      tableData.data[num].recharge_status = tableData.data[num].recharge_status.replace(/^3$/g, '续费失败')
      tableData.data[num].recharge_status = tableData.data[num].recharge_status.replace(/^4$/g, '续费成功')
      tableData.data[num].recharge_status = tableData.data[num].recharge_status.replace(/^5$/g, '未知')
    } */
    /* if (tableData.data[num].pay_type) {
      tableData.data[num].pay_type = tableData.data[num].pay_type.replace(/^0$/g, '语音报警')
      tableData.data[num].pay_type = tableData.data[num].pay_type.replace(/^1$/g, '短信报警')
      tableData.data[num].pay_type = tableData.data[num].pay_type.replace(/^2$/g, '录音报警')
      tableData.data[num].pay_type = tableData.data[num].pay_type.replace(/^3$/g, '微信推送')
      tableData.data[num].pay_type = tableData.data[num].pay_type.replace(/^4$/g, '微信订阅消息推送')
    } */
    if (tableData.data[num].notify_result) {
      tableData.data[num].notify_result = tableData.data[num].notify_result.replace(/^0$/g, '发出错误')
      tableData.data[num].notify_result = tableData.data[num].notify_result.replace(/^1$/g, '已成功发出')
      tableData.data[num].notify_result = tableData.data[num].notify_result.replace(/^2$/g, '获取反馈超时')
      tableData.data[num].notify_result = tableData.data[num].notify_result.replace(/^3$/g, '获取失败反馈')
      tableData.data[num].notify_result = tableData.data[num].notify_result.replace(/^4$/g, '通知成功')
      tableData.data[num].notify_result = tableData.data[num].notify_result.replace(/^5$/g, '用户已接电话')
    }
    if (tableData.data[num].config_type) {
      tableData.data[num].config_type = tableData.data[num].config_type.replace(/^1$/g, '云之讯')
      tableData.data[num].config_type = tableData.data[num].config_type.replace(/^2$/g, '阿里')
      tableData.data[num].config_type = tableData.data[num].config_type.replace(/^3$/g, '腾讯')
      tableData.data[num].config_type = tableData.data[num].config_type.replace(/^4$/g, '呼叫电话分配')
      tableData.data[num].config_type = tableData.data[num].config_type.replace(/^5$/g, '短信内容')
    }
    if (tableData.data[num].working_status) {
      tableData.data[num].working_status = tableData.data[num].working_status.replace(/^0$/g, '正常')
      tableData.data[num].working_status = tableData.data[num].working_status.replace(/^1$/g, '快到期')
      tableData.data[num].working_status = tableData.data[num].working_status.replace(/^2$/g, '到期')
      tableData.data[num].working_status = tableData.data[num].working_status.replace(/^3$/g, '未知')
    }
    if (tableData.data[num].which_isp) {
      tableData.data[num].which_isp = tableData.data[num].which_isp.replace(/^1$/g, '云之讯')
      tableData.data[num].which_isp = tableData.data[num].which_isp.replace(/^2$/g, '阿里')
      tableData.data[num].which_isp = tableData.data[num].which_isp.replace(/^3$/g, '腾讯')
    }
    if (tableData.data[num].app_platform) {
      tableData.data[num].app_platform = tableData.data[num].app_platform.replace(/^0$/g, 'IOS')
      tableData.data[num].app_platform = tableData.data[num].app_platform.replace(/^1$/g, 'Android')
      tableData.data[num].app_platform = tableData.data[num].app_platform.replace(/^2$/g, 'Applets')
      tableData.data[num].app_platform = tableData.data[num].app_platform.replace(/^3$/g, 'Web')
    }
    if (tableData.data[num].agent_district) {
      tableData.data[num].agent_district = tableData.data[num].agent_district.replace(/^1$/g, 'provinceAgency')
      tableData.data[num].agent_district = tableData.data[num].agent_district.replace(/^2$/g, 'cityAgency')
      tableData.data[num].agent_district = tableData.data[num].agent_district.replace(/^3$/g, 'countyAgency')
    }
    if (tableData.data[num].order_status) {
      tableData.data[num].order_status = tableData.data[num].order_status.replace(/^0$/g, 'unprocessed')
      tableData.data[num].order_status = tableData.data[num].order_status.replace(/^1$/g, 'inprocess')
      tableData.data[num].order_status = tableData.data[num].order_status.replace(/^2$/g, 'processed')
      tableData.data[num].order_status = tableData.data[num].order_status.replace(/^3$/g, 'closed')
    }
    if (tableData.data[num].problem_status) {
      tableData.data[num].problem_status = tableData.data[num].problem_status.replace(/^0$/g, 'Unresolved')
      tableData.data[num].problem_status = tableData.data[num].problem_status.replace(/^1$/g, 'Resolved')
    }
    if (tableData.data[num].satisfy) {
      tableData.data[num].satisfy = tableData.data[num].satisfy.replace(/^0$/g, 'dissatisfied')
      tableData.data[num].satisfy = tableData.data[num].satisfy.replace(/^1$/g, 'satisfied')
      tableData.data[num].satisfy = tableData.data[num].satisfy.replace(/^2$/g, 'verySatisfied')
    }
    if (tableData.data[num].result) {
      tableData.data[num].result = tableData.data[num].result.replace(/^0$/g, 'failed')
      tableData.data[num].result = tableData.data[num].result.replace(/^1$/g, 'success')
    }
  }
  return tableData
}

export function replaceColumn(column) {
  console.log(`column.length: ${column.length}`)
  for (var num = 0; num < column.length; num++) {
    column[num] = column[num].replace(/device_key/g, '设备ID')
    column[num] = column[num].replace(/product_key/g, '设备型号')
    column[num] = column[num].replace(/mac/g, 'MAC地址')
    column[num] = column[num].replace(/module_hd_ver/g, '模组硬件版本号')
    column[num] = column[num].replace(/module_sw_ver/g, '模组软件版本号')
    column[num] = column[num].replace(/device_name/g, '设备名称')
    column[num] = column[num].replace(/first_online_time/g, '首次上线')
    column[num] = column[num].replace(/last_online_time/g, '最近一次上线')
    column[num] = column[num].replace(/device_status/g, '设备在线状态')
    column[num] = column[num].replace(/online_count/g, '上线次数')
    column[num] = column[num].replace(/product_name/g, '产品名称')
    column[num] = column[num].replace(/project_name/g, '项目名称')
    column[num] = column[num].replace(/stage/g, '产品阶段')
    column[num] = column[num].replace(/position/g, '设备位置')
    column[num] = column[num].replace(/import_time/g, '导入时间')
    column[num] = column[num].replace(/update_time/g, '最近信息更改时间')
    column[num] = column[num].replace(/last_alarm_time/g, '最近报警时间')
    column[num] = column[num].replace(/alarm_status/g, '报警状态')
    column[num] = column[num].replace(/import_user/g, '导入者账号')
    column[num] = column[num].replace(/distributer_user/g, '代理商账号')
    column[num] = column[num].replace(/end_user/g, '使用者账号')
    column[num] = column[num].replace(/project_key/g, '工程号')
    column[num] = column[num].replace(/device_sn/g, '设备编号')
    column[num] = column[num].replace(/install_date/g, '施工日期')
  }
  return column
}

export function deepClone(obj) {
  const newObj = obj.push ? [] : {}
  for (const attr in obj) {
    if (typeof obj[attr] === 'object') {
      newObj[attr] = deepClone(obj[attr])
    } else {
      newObj[attr] = obj[attr]
    }
  }
  return newObj
}

export function copyObj(obj) {
  const cloneObj = {}
  for (const key in obj) {
    cloneObj[key] = deepClone(obj[key])
  }

  return cloneObj
}
